import React from "react";
import { CardBase } from "./partials/CardBase";
export const InstructorListCard = (props) => {
    const { article } = props;
    return (React.createElement(CardBase, { imageUrl: article.imageUrl, title: article.title, link: `/instructor/${props.article.id}`, isLast: props.isLast, noOfFollowers: props.article.popularityScore, description: article.description }));
};
//# sourceMappingURL=InstructorListCard.js.map